export default __webpack_public_path__ + "static/media/pl.2b5541c5.svg";